exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paging__container___j77PM {\n  cursor: pointer;\n  height: 14px;\n  width: 14px;\n  background-color: #C4C4C4;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 10px;\n  margin-top: 10px; }\n\n.slick-active .paging__container___j77PM {\n  background-color: #f94144; }\n", ""]);

// exports
exports.locals = {
	"container": "paging__container___j77PM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/AdDetailsPage/AdDetailsPageMobile/SimilarAdsSection/SimilarAdsCarousel/Paging/paging.scss
// module id = 4548
// module chunks = 6